import { createCategory } from './api';
import { splitCategoryLabel } from './import';
import type { Category, FinanceCategoryKind } from './types';

/** Create missing `Parent - Child` categories; returns lowercased label → leaf id. */
export async function ensureCategoriesFromLabels(
  labels: string[],
  categories: Category[],
  kind: FinanceCategoryKind = 'expense',
): Promise<{ categories: Category[]; byLabel: Map<string, number> }> {
  const byLabel = new Map<string, number>();
  let pool = [...categories];

  const findTop = (name: string) =>
    pool.find((c) => c.parentId == null && c.name.toLowerCase() === name.toLowerCase());
  const findChild = (parentId: number, name: string) =>
    pool.find((c) => c.parentId === parentId && c.name.toLowerCase() === name.toLowerCase());

  for (const label of labels) {
    const key = label.toLowerCase();
    if (byLabel.has(key)) continue;

    const { parent, child } = splitCategoryLabel(label);

    let parentRow = findTop(parent);
    if (!parentRow) {
      parentRow = await createCategory({ name: parent, kind });
      pool = [...pool, parentRow];
    }
    let target = parentRow;
    if (child) {
      let childRow = findChild(parentRow.id, child);
      if (!childRow) {
        childRow = await createCategory({ name: child, parentId: parentRow.id, kind });
        pool = [...pool, childRow];
      }
      target = childRow;
    }
    byLabel.set(key, target.id);
  }

  return { categories: pool, byLabel };
}
